import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AIShowcase, Faq, Features, FinalCta, Footer, Hero, Logos, Nav, Pricing, Stats, Testimonials } from "./landing/sections";
import VatCalculator from "./landing/VatCalculator";
import { FormationTeaser } from "./Formation";

export default function Landing() {
  const { user } = useAuth();
  if (user) return <Navigate to="/dashboard" replace />;
  return (
    <div data-testid="landing-page" className="min-h-screen scroll-smooth bg-[#04140B] text-white selection:bg-[#D4AF37]/40">
      <Nav />
      <Hero />
      <Stats />
      <Logos />
      <Features />
      <AIShowcase />
      <VatCalculator />
      <Testimonials />
      <Pricing />
      <FormationTeaser />
      <Faq />
      <FinalCta />
      <Footer />
    </div>
  );
}
